// Pure constants module — no imports.
// Extracted from config.js to avoid a circular dependency between config.js and utils.js
// (config.js imports adapter functions from utils.js, utils.js needs URL_TYPES/IMAGE_TYPES/ASPECT_RATIO_TYPES).

// According to Yams rules
export const IMAGE_TYPES = {
  GALLERY: 'original',
  ORIGINAL: 'original',
  THUMBNAIL: 'thumbnail',
  CARD_S: 'articleCardS',
  CARD_M: 'articleCardM',
  CARD_L: 'articleCardL',
  ARTICLE_BODY: 'articleBodyImage',
  MOBILE_ARTICLE_BODY: 'mobileArticleBodyImage',
  ARTICLE_MAIN_IMAGE_META: 'articleMainImageMeta',
  ARTICLE_MAIN_IMAGE_META_43: 'articleMainImageMeta43',
  ARTICLE_MAIN_IMAGE_META_11: 'articleMainImageMeta11',
  AVATAR: '200x200'
}

export const TRANSFORM_TYPES = {
  DEVICE_CROP: 'deviceCrop',
  ORIGINAL: 'original'
}

export const URL_TYPES = {
  OTHER: 'other',
  PINCHER: 'pincher',
  YAMS: 'yams',
  FASTLY: 'fastly',
  PRO_FASTLY: 'proFastly',
  PRECF_MEDIA: 'precfMedia'
}

export const ASPECT_RATIO_TYPES = {
  FULL_SCREEN: 1.33, // aspect-ratio 4/3
  WIDE_SCREEN: 1.78 // aspect-ratio 16/9
}

export const DEFAULT_OPTIONS = {
  aspectRatio: ASPECT_RATIO_TYPES.FULL_SCREEN,
  imageType: IMAGE_TYPES.GALLERY,
  transformType: TRANSFORM_TYPES.DEVICE_CROP
}

export const DEFAULT_ASPECT_RATIO = ASPECT_RATIO_TYPES.FULL_SCREEN
